import Vue from 'vue';
import Element from 'element-ui';
import '../styles/element-variables.scss';
import locale from 'element-ui/lib/locale/lang/es';

Vue.use(Element, { locale });
